import React, { useState } from "react";
import { footer_icon1, footer_icon2, footer_icon3, footer_icon4, footer_logo, logo, inbox, location, phone } from '../../assets/images'
import PrivacyPolicy from '../pages/PrivacyPolicy';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = () => {
    if (!email) {
      alert("Please enter a valid email.");
      return;
    }
    // Clear the input field
    setEmail("");

    // Optional: Show success message
    alert(`Thank you! Your email has been submitted successfully.`);
  };

  const currentYear = new Date().getFullYear();

  return (
    <>
      <div className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-12 col-md-6 p-2 mt-md-5 mt-0">
              <div className="div p-0  px-0 text-white">
                <img src={footer_logo} className='footer-logo     ' alt="" />
                <p className="footer-logo-para  text-start mt-md-4 mt-3 mb-3">Trusted experts in revenue cycle management boosting your cash flow, reducing admin load, and driving lasting growth.  </p>
                {/* <p className='text-muted footer-email text-start mt-4'>Email to : <span className="text-white fw-bold">hello@probillrcm.com</span> </p>
                <h5 className='text-start text-white mt-4 text-muted footer-email'>Contact Us :  <span className="text-white fw-bold">216-678-6887</span></h5>
                <p className='text-start footer-email mt-4 text-white'>30799 Pinetree Rd., #432, Pepper Pike, OH 44124 </p> */}
                <div className="d-flex justify-content-start media-icon">
                  {/* <img src={footer_icon2} className='footer-icon' alt="" />
                  <img src={footer_icon1} className='footer-icon' alt="" />
                  <img src={footer_icon3} className='footer-icon' alt="" />
                  <img src={footer_icon4} className='footer-icon' alt="" /> */}


                  <a href="tel:+1 (216) 678-6887" className='nav-link text-decoration-none px-0 p-0 cp '>
                    <img src={phone} className='footer-icon ms-0' alt="" /></a>
                  <a className="nav-link text-decoration-none px-0 p-0 cp" href="mailto:hello@probillrcm.com">
                    <img src={inbox} className='footer-icon' alt="" /></a>
                  <a className="nav-link text-decoration-none px-0 p-0 cp" target="_blank"
                    href="https://www.google.com/maps/dir//PLOT+NO-24,+Industrial+Area+Phase+I,+Chandigarh,+160002/@30.7112934,76.726247,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x390fedd48e0726fd:0xf56df5895b18d3b1!2m2!1d76.8086483!2d30.7113194!5m1!1e1?entry=ttu&g_ep=EgoyMDI1MDkyOC4wIKXMDSoASAFQAw%3D%3D" rel="noreferrer">

                    <img src={location} className='footer-icon' alt="" />
                  </a>

                </div>
                <div class="row mx-auto mt-3 d-none d-md-flex">
                  <div class="col-auto px-0 px-xl-1 me-md-4 me-0">

                    <Link to={"/terms-conditions"} className='footer-bottom-link ' style={{ color: 'rgba(255, 255, 255, 1)', textDecoration: "none!important" }}>Terms & Conditions</Link>
                    <hr className='mt-0 mb-0' />
                  </div>
                  <div class="col-auto px-5 px-xl-1">

                    <Link to={"/privacy-policy"} className='footer-bottom-link' style={{ color: 'rgba(255, 255, 255, 1)', textDecoration: "none!important" }} >Privacy Policy</Link>
                    <hr className='mt-0 mb-0' />

                  </div>
                </div>
              </div>
              <img src={footer_logo} className='footer-logo d-none d-lg-none ms-5 px-2' alt="" />

              <div className="div  flex-md-column  d-lg-none d-none p-0 px-0 text-white">
                <div className="div">
                  <p className="footer-logo-para  text-start mt-4">Trusted experts in revenue cycle management boosting your cash flow, reducing admin load, and driving lasting growth.  </p>
                </div>
                <div className="div mt-1 mt-md-0">
                  {/* <p className='text-muted   m-0 text-md-start text-lg-end text-start  mt-4'>Email to : <span className="text-white fw-medium " style={{ fontSize: '14px' }}>hello@ProBillRCM.com</span> </p>
                  <h5 className=' text-white  text-muted text-lg-end text-start  text-md-start m-0 '> Contact us : <span className="text-white fw-medium " style={{ fontSize: '14px' }}>216-678-6887</span></h5>
                  <p className=' footer-email text-md-start text-lg-end text-start   text-white'>2972 Westheimer Rd. Santa <br /> Ana, Illinois 85486 </p> */}
                </div>
              </div>
            </div>
            <div className=" col-6 col-md-4 col-lg-4 mt-lg-5 p-2 d-flex justify-content-md-center justify-content-start d-none d-md-block">
              <div className="div">
                <h5 className='text-start  footer-link-head mb-3' style={{ color: "#B1510F" }}>Quick Link</h5>
                <a href='/industries/accounts-receivable' className="footer-email my-2 text-white text-start text-decoration-none d-block">What we do</a>
                <a href='/services/nurse-practitioners' className="footer-email my-2 text-white text-start text-decoration-none d-block">Who we help</a>
                <a href="/about" className="footer-email my-2 text-white text-start text-decoration-none d-block">About</a>
                <a href="/blog" className="footer-email my-2 text-white text-start text-decoration-none d-block">Blogs</a>
                <a href="/contact" className="footer-email my-2 text-white text-start text-decoration-none d-block">Contact Us</a>

              </div>
            </div>
            <div className=" col-12 col-md-4 col-lg-4 mt-lg-5 p-2 d-flex justify-content-md-center justify-content-start d-md-none d-block">
              <div className="row">
                <h5 className='text-start  footer-link-head mb-3' style={{ color: "#B1510F" }}>Quick Link</h5>
                <div className="col-12">
                  <div className="row">
                    <div className="col-5">
                      <a href='/industries/accounts-receivable' className="footer-email my-2 text-white text-start text-decoration-none d-block">What we do</a>

                    </div>
                    <div className="col-6">
                      <a href="/contact" className="footer-email my-2 text-white text-start text-decoration-none d-block">Contact Us</a>

                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="row">
                    <div className="col-5">
                      <a href='/services/nurse-practitioners' className="footer-email my-2 text-white text-start text-decoration-none d-block">Who we help</a>

                    </div>
                    <div className="col-6">
                      <a href="/blog" className="footer-email my-2 text-white text-start text-decoration-none d-block">Blogs</a>

                    </div>
                  </div>
                </div>
                <a href="/about" className="footer-email my-2 text-white text-start text-decoration-none d-block">About</a>

              </div>
            </div>
            {/* <div className="col-6 col-md-3 col-lg-2 mt-lg-5 p-2 d-flex justify-content-center">
              <div className="div">
                <h5 className='text-start text-white footer-link-head'>Social Media</h5>
                <p className="footer-email text-white text-start">Facebook</p>
                <p className="footer-email text-white text-start">Instagram</p>
                <p className="footer-email text-white text-start">Youtube</p>
                <p className="footer-email text-white text-start">twiter</p>

              </div>
            </div> */}
            <div className="col-12 col-lg-4 mt-lg-5 p-2 d-flex justify-content-center">
              <div className="div">
                <h5 className='text-start footer-link-head mb-3' style={{ color: "#B1510F" }}>Newsletter</h5>
                <p className="footer-email  text-start">Subscribe to our newsletter for the latest insights, industry updates, and expert tips on optimizing your revenue cycle.  </p>
                <div
                  className="d-flex mt-lg-3 bg-white p-1"
                  style={{ borderRadius: "10px" }}
                >
                  <input
                    type="email"
                    className="form-control input px-4 border-0"
                    placeholder="Enter your email ID"
                    aria-label="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button className="btn input-btn text-white" type="button" onClick={handleSubmit}>
                    Submit
                  </button>
                </div>
                {/* <h5 className='text-start d-none d-lg-block mt-lg-3 text-white'>Follow Us on:</h5>
               
                <div className="d-flex d-lg-none mt-3  justify-content-center media-icon">
                  <h5 className='text-start mt-lg-5 text-white mt-2'>Follow Us on:</h5>

                  <img src={footer_icon2} className='footer-icon' alt="" />
                  <img src={footer_icon1} className='footer-icon' alt="" />
                  <img src={footer_icon3} className='footer-icon' alt="" />
                  <img src={footer_icon4} className='footer-icon' alt="" />

                </div> */}

              </div>
            </div>
            <div class="row mx-auto mt-1 mb-2 d-flex d-md-none">
              <div class="col-auto px-0 px-xl-1 me-md-4 me-0">

                <Link to={"/terms-conditions"} className='footer-bottom-link ' style={{ color: 'rgba(255, 255, 255, 1)', textDecoration: "none!important" }}>Terms & Conditions</Link>
                <hr className='mt-0 mb-0' />
              </div>
              <div class="col-auto px-5 px-xl-1">

                <Link to={"/privacy-policy"} className='footer-bottom-link' style={{ color: 'rgba(255, 255, 255, 1)', textDecoration: "none!important" }} >Privacy Policy</Link>
                <hr className='mt-0 mb-0' />

              </div>
            </div>
          </div>

        </div>
        <div className="row mx-auto mt-md-5 mt-2 " style={{ borderTop: "1px solid #B1510F" }}>
          <div className="col-12 py-md-4 pt-2 pb-0">
            <div className="div d-flex align-items-center justify-content-center">
              <p className='footer-bottom-link mb-0' style={{ color: 'rgba(255, 255, 255, 1)' }}>
                © {currentYear} ProBillRCM | All Rights Reserved | Powered By{" "}
                <a
                  className='fw-bold text-white add_underline'
                  target="_blank"
                  rel="noopener noreferrer"
                  href='https://rowthtech.com/'
                >
                  RowthTech
                </a>
              </p>            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer
